import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';


// Base Element for sbk
export class SbkElement extends LitElement {

    /* used for id */
    @property({type: String})
    identifier? = ''

    /* used for additional classes */
    @property({type: String})
    classes? = '';

    /* used to add additional attribtutes like aria-attributes */
    @property({type: String})
    data? = '';
}